// import React, { useState, useEffect } from 'react';
// import { getAllBanner, getRightGif } from '../service/base';
// import { CONST_SITE } from '../utils/common/const';
// import qs from 'query-string';

// const RightGif = () => {
//   const [gifUrl, setGifUrl] = useState('');
//   const [error, setError] = useState(null);
//   const [gifLink, setGifLink] = useState('');
//   const [isVisible, setIsVisible] = useState(true);
//   const [showButton, setShowButton] = useState(false);

//   useEffect(() => {
//     const fetchGif = async () => {
//       try {
//         const response = await getAllBanner(qs.stringify({ site: CONST_SITE.OK9 }));
//         if (response?.data?.[0]) {
//           const gifData = response.data[0];
//           setGifUrl(gifData.image);
//           setGifLink(gifData.link || '');
//         } else {
//           console.warn('No GIF data found in response');
//           setError('No GIF data found');
//         }
//       } catch (error) {
//         console.error('Error fetching right GIF:', error);
//         setError(error.message);
//       }
//     };

//     fetchGif();
//   }, []);

//   const handleClick = () => {
//     if (gifLink) {
//       window.open(gifLink, '_blank');
//     }
//   };

//   const handleClose = (e) => {
//     e.stopPropagation();
//     setIsVisible(false);
//     setShowButton(true);
//   };

//   const handleShow = () => {
//     setIsVisible(true);
//     setShowButton(false);
//   };

//   if (error || !gifUrl) {
//     return null;
//   }

//   if (!isVisible) {
//     if (showButton) {
//       return (
//         <button
//           onClick={handleShow}
//           className="fixed right-2 top-1/2 -translate-y-1/2 z-50 bg-green-500 text-white w-8 h-8 rounded-l-lg shadow-lg flex items-center justify-center"
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             viewBox="0 0 24 24"
//             fill="currentColor"
//             className="w-5 h-5 transform rotate-90"
//           >
//             <path d="M12 4l-8 8h16l-8-8z" />
//           </svg>
//         </button>
//       );
//     }
//     return null;
//   }

//   return (
//     <div className="fixed right-2 lg:right-10 top-1/2 -translate-y-1/2 z-50 cursor-pointer">
//       <button
//         onClick={handleClose}
//         className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center text-sm font-bold z-10"
//       >
//         ×
//       </button>
//       <img
//         src={gifUrl}
//         alt="Right GIF"
//         className="max-w-20 lg:max-w-[150px] cursor-pointer"
//         onClick={handleClick}
//         onError={(e) => {
//           console.error('Error loading GIF image:', e);
//           setError('Failed to load image');
//         }}
//       />
//     </div>
//   );
// };

// export default RightGif;

import React, { useState, useEffect } from 'react';
import { getAllBanner } from '../service/base';
import { CONST_SITE } from '../utils/common/const';
import qs from 'query-string';

const RightGif = () => {
  const [banners, setBanners] = useState([]);
  const [error, setError] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await getAllBanner(qs.stringify({ site: CONST_SITE.OK9 }));
        if (response?.data) {
          setBanners(response.data);
        } else {
          console.warn('No banner data found in response');
          setError('No banner data found');
        }
      } catch (error) {
        console.error('Error fetching banners:', error);
        setError(error.message);
      }
    };

    fetchBanners();
  }, []);

  const handleClick = (link) => {
    if (link) {
      window.open(link, '_blank');
    }
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setIsVisible(false);
    setShowButton(false); // Không hiển thị button show nữa
  };

  if (error || banners.length === 0) {
    return null;
  }

  // Nếu đã đóng thì không hiển thị gì
  if (!isVisible) {
    return null;
  }

  // Hiển thị banners với button close
  return (
    <div className="fixed right-2 lg:right-10 top-1/2 -translate-y-1/2 z-50 cursor-pointer">
      <button
        onClick={handleClose}
        className="absolute -top-2 -right-2 w-7 h-7 bg-[#31a749] text-white rounded-full flex items-center justify-center text-sm font-bold z-10 border-2 border-white"
      >
        ×
      </button>
      {banners.map((banner, index) => (
        <div className="flex" key={banner.id || banner.image || index}>
          <a
            className="max-w-20 lg:max-w-[140px] flex"
            href={banner?.link ?? '#'}
            title={banner?.title}
          >
            <img
              src={banner.image}
              alt={banner?.title ?? `Banner ${index}`}
              className="w-full h-auto cursor-pointer mb-2"
            />
          </a>
        </div>
      ))}
    </div>
  );
};

export default RightGif;
